module.exports = __webpack_public_path__ + "assets/Feedback.6cad64f0.svg";